import Analytics from 'vue-analytics';
import Router from 'vue-router';
import Event from './EventCard.vue';
import FormFinder from './App.vue';
import FormSelections from './FormSelections.vue';
import EventSelection from './EventSelection.vue';
import FormFilters from './FormFilters.vue';
import state from './state';
import types from './state/types';
import VStyle from '@/utils/VStyle';

// We are intentionally exposing components that *may* be required by the bundle-consumer
// Source-code-consumers like odds.com.au can directly import modules, so are not affected
export default {
  Analytics,
  Router,
  Event,
  FormFinder,
  FormSelections,
  EventSelection,
  FormFilters,
  state,
  types,
  VStyle,
};
